import axios from 'axios'
import { initShopeepayReporter, instrumentAxios } from '@shopeepay/reporter'

// Source of truth: src/Navigation/index.js NAVIGATION_ROUTES + redirect
// routes in src/index.js. VN has dynamic promo IDs (`/khuyen-mai/:id` etc.)
// and a `/tin-tuc/*` wildcard redirect — the `:id`, `:category`, `:slug`,
// `:bankName` templates bucket those under one label so dynamic IDs don't
// blow up cardinality.
const KNOWN_ROUTES = [
  '/',
  '/#about',
  '/#aboutUs',
  '/doi-tac#merchantApp',
  '/chinh-sach-bao-mat',
  '/chinh-sach-bao-mat/07-2024',
  '/chinh-sach-ve-su-dong-y-cua-nguoi-dung',
  '/contactus',
  '/dich-vu',
  '/dieu-khoan-su-dung',
  '/doi-tac',
  '/gioi-thieu',
  '/hop-tac-doanh-nghiep',
  '/khuyen-mai',
  '/khuyen-mai/:id',
  '/khuyen-mai-da-ket-thuc',
  '/khuyen-mai-da-ket-thuc/:id',
  '/khuyen-mai-dang-dien-ra/:id',
  '/khuyen-mai/live/preview/:id',
  '/khuyen-mai/test/preview/:id',
  '/lien-he-chung-toi',
  '/lien-ket-ngan-hang',
  '/lien-ket-ngan-hang/:bankName',
  '/register',
  '/seasy-vay-tien-nhanh-dieu-khoan-su-dung',
  '/spaylater-dieu-khoan-su-dung',
  '/tai-ung-dung',
  '/tin-tuc',
  '/tin-tuc/:slug',
  '/tinh-nang',
  '/verify',
]

initShopeepayReporter({
  region: 'vn',
  project: 'shopeepay-vn',
  knownRoutes: KNOWN_ROUTES,
})
instrumentAxios(axios, 'shopeepay-vn')
